const forms = document.querySelectorAll('.wp-form');

forms.forEach(form => {
    const swither = form.querySelector('[role="switch"]');
    const formProductsWrapper = form.querySelector('.form-products-wrapper');

    if (swither) {
        swither.addEventListener('click', () => {
            if (formProductsWrapper.style.display === 'block') {
                formProductsWrapper.style.display = 'none'
            } else {
                formProductsWrapper.style.display = 'block'
            }
        })
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (form.checkValidity()) {
            const allInputs = form.querySelectorAll('input');
            const allInputsData = [];
            allInputs.forEach(input => {
                allInputsData[input.dataset.email] = input.value;
            });

            allInputsData['message'] = '';
            if (form.querySelector('textarea')) {
                allInputsData['message'] = form.querySelector('textarea').value
            }

            allInputs['products_number'] = '';
            if (allInputsData['quotation'] === 1) {
                allInputsData['products_number'] = form.querySelector('[name="products"]').value
            }

            const allInputsDataMap = new Map();
            allInputs.forEach(input => {
                allInputsDataMap.set(input.dataset.email, input.value);
            });

            const allInputsDataObject = Object.fromEntries(allInputsDataMap)

            fetch(bimForm.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: new URLSearchParams({
                    action: 'bim_send_email',
                    ajaxNonce: bimForm.ajaxnonce,
                    name: allInputsData['name'],
                    email: allInputsData['email'],
                    phone: allInputsData['phone'],
                    products_number: allInputsData['products_number'],
                    message: allInputsData['message'],
                })
            }).then(response => {
                return response.json()
            }).then(response => {
                gtag('event', 'formSubmit', {
                    'event_category': allInputsData['event'],
                    'event_label': window.location.pathname,
                    'event_callback': function () {
                        window.location.href = bimForm.thankYouPageUrl
                    }
                });
            }).catch((error) => console.log(error));
        }
    })
})


const backToPreviousPageButton = document.querySelector('#back-to-previous-page');
if (backToPreviousPageButton) {
    backToPreviousPageButton.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        window.history.go(-1);
        return false;
    })
}
